import type { Router } from 'vue-router';
import { useRecordStore } from '@/store/modules/record';
import { getToken } from '@/utils/auth';
const whiteList = [
  '/policy',
  '/download',
  '/train-schedule',
  '/train-schedule-detail',
  '/train-schedule-edit',
  '/train-schedule-type',
  '/gpt',
  '/introduction-weview'
];
export function setupRouterPermission(router: Router) {
  router.beforeEach(async (to, from, next) => {
    const recordStore = useRecordStore();
    if (getToken()) {
      if (to.path.includes('/login')) {
        next('/');
      } else {
        // await recordStore._getDefaultRecord();
        next();
      }
    } else {
      if (to.path.includes('/login')) {
        next();
      } else if (whiteList.includes(to.path)) {
        next();
      } else {
        next(`/login?redirect=${to.path}`);
      }
    }
  });
  router.afterEach((to, from, failure) => {
    // console.log(failure);
  });
}
